import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicBedWhichBig({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.32 5.1c-.76 0-1.37.6-1.37 1.36v.5H2.4V4.12c0-1 .65-1.6 1.6-1.6h8c.95 0 1.6.57 1.6 1.6v2.84h-2.62v-.5A1.36 1.36 0 009.6 5.1H6.3zM2.5 7.57h7.16a5 5 0 00-2.6 3.64h-4.1v1.45a.45.45 0 01-.45.45h-.57a.45.45 0 01-.45-.45V8.58a1 1 0 011-1zM16 12a4 4 0 11-8 0 4 4 0 018 0zm-2.55-.78a1.05 1.05 0 00-.08-.84c-.1-.16-.2-.3-.35-.41-.14-.11-.3-.2-.47-.27a1.66 1.66 0 00-2.03.76.13.13 0 00-.02.1c0 .03.02.05.05.08l.54.4c.02.02.05.03.08.03.04 0 .07-.02.1-.06.15-.19.27-.31.34-.37.1-.06.21-.1.36-.1a.6.6 0 01.34.11c.1.07.15.15.15.24 0 .1-.02.19-.08.25a.8.8 0 01-.27.18c-.17.08-.32.2-.46.35a.75.75 0 00-.21.51v.28c0 .04 0 .08.03.12.02.04.05.06.08.06h.78c.04 0 .07-.02.1-.05a.17.17 0 00.03-.1.9.9 0 01.09-.36.53.53 0 01.22-.2 5.85 5.85 0 00.39-.26.92.92 0 00.18-.2.84.84 0 00.11-.25zM12 14.4a.67.67 0 100-1.35.67.67 0 000 1.35z"
      />
    </svg>
  );
}

SvgBasicBedWhichBig.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicBedWhichBig.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBasicBedWhichBig svgRef={ref} {...props} />
));
export default ForwardRef;
